<template>
  <div class="class-list">
    <GlobalInfoBar
      icon="custom"
      title="限时红包设置"
      content="限时价加红包是为帮助小程序门店灵活的展示显示价格，以展示加价的方式吸引顾客下单回收。"
    >
      <img class="info-bar_icon" src="@/assets/images/icon_pay_set.png" alt />
    </GlobalInfoBar>
    <div class="class_type" style="margin-bottom: 20px">
      <el-radio-group v-model="calssSelect">
        <el-radio-button label="01">预估价设置</el-radio-button>
        <el-radio-button label="02">限时红包设置</el-radio-button>
      </el-radio-group>
      <div class="time-box">
        <span style="margin-right: 40px">最近提交时间：{{config && config.updateTime || '--'}}</span>
        <span>生效时间：{{config && config.enableTime || '--'}}</span>
      </div>
    </div>
    <GlobalChunk icon="vertical">
      <Future ref="future" v-show="calssSelect == '01'" :config="config" />
      <Table ref="table" v-show="calssSelect == '02'" :config="config" />
    </GlobalChunk>
    <div class="mt-10">
      <el-button :loading="btnLoading" type="primary" @click="save(false)">提交次日生效</el-button>
      <el-button :loading="btnLoading" type="warning" @click="save(true)">提交立即生效</el-button>
    </div>
    <el-dialog
      title="保存提示"
      :visible.sync="dialogSubmitVisible"
      :close-on-click-modal="false"
      width="380px"
    >
      <div class="del-title">
        <div class="sure_tip">确认要保存本次设置吗？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="dialogSubmitVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          :loading="btnLoading"
          @click.native="handleSuccessSave"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import Future from './Future.vue';
import Table from "./Table";
export default {
  name: "class-list",
  components: {
    Table,
    Future,
  },
  data() {
    return {
      calssSelect: '01',
      config: null,
      btnLoading: false,
      dialogSubmitVisible: false,
      // isImmediate: false,
      requestParams: null
    };
  },
  created() {
    this.getPayconfig()
  },
  methods: {
    getPayconfig() {
      _api.getPayconfig().then((res) => {
        this.config = res.data
      });
    },
    save(isImmediate) {
      const tableParams = this.$refs['table'].getParams()
      const futureParams = this.$refs['future'].getParams()
      const requestParams = {
        ...futureParams,
        ...tableParams,
        // factorRate: this.factorRate,
        // usePayConfig: this.usePayConfig,
        // showPriceType: this.showPriceType,
        // userPriceShowRegionList: this.userPriceShowRegionList,
        isImmediate
      }
      this.requestParams = requestParams
      this.dialogSubmitVisible = true
    },
    handleSuccessSave() {
      _api.savePayconfig(this.requestParams).then(res => {
        this.$message.success("操作成功");
        this.getPayconfig()
        this.dialogSubmitVisible = false
      }).finally(() => {
        this.btnLoading = false
      })
    },
  },
};
</script>
<style lang="scss">
.mt-10 {
  margin-top: 10px;
}
.class_type{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.time-box{
  font-size: 12px;
}
</style>